import { Navigate } from 'react-router-dom';

import Home from '../pages/home/Home'; // Import your Home component
import SignIn from '../pages/sign-in/SignIn'; // Import your Home component

import Inventory from '../pages/inventory/Inventory.jsx'; // Import your MenuContent component

import About from '../pages/about/About';
import ApprovalQueue from '../pages/approvalQueue/ApprovalQueue';
import Clins from '../pages/clins/Clins';
import CTPForm from '../pages/ctp/CTPForm';
import CTPList from '../pages/ctp/CTPList';
import Deliverables from '../pages/deliverables/Deliverables';
import Dodlinks from '../pages/dodlinks/DodLinks';
import Feedback from '../pages/feedback/Feedback';
import Financials from '../pages/financials/Financials';
import Help from '../pages/help/Help';
import IRO from '../pages/iro/Iro';
import Logistics from '../pages/logistics/Logistics';
import MasterSchedule from '../pages/master-schedule/MasterSchedule';
import Org from '../pages/org/Org';
import Personnel from '../pages/personnel/Personnel';
import Projects from '../pages/projects/Projects';
import QualityControl from '../pages/qualityControl/QualityControl.jsx';
import RIPForm from '../pages/rip/RIPForm';
import RIPList from '../pages/rip/RIPList';
import Risk from '../pages/risk/Risk.jsx';
import Settings from '../pages/settings/Settings';
import TARForm from '../pages/tar/TARForm';
import TARList from '../pages/tar/TARList.jsx';
import IMCSTARForm from '../pages/tar-imcs/IMCSTARForm';
import IMCSTARList from '../pages/tar-imcs/IMCSTARList.jsx';
import TRForm from '../pages/tr/TRForm';
import TRList from '../pages/tr/TRList.jsx';
import WorkFlow from '../pages/workflow/Workflow';
// import KineticFormPage from '../pages/kinetic/KineticFormPage';
import AdminLanding from '../pages/admin/AdminLanding.js';
import Library from '../pages/library/Library';
import Notifications from '../pages/notifications/Notifications';
import PNRForm from '../pages/pnr/PNRForm.jsx';
import PNRList from '../pages/pnr/PNRList.jsx';
import Preferences from '../pages/preferences/Preferences';

// D.4 Admin routes. A single AdminLanding component services `/admin`,
// `/admin/platform`, `/admin/program`, and `/admin/project`. The live embeds
// (UserSettings, SitewideSettings, FormVisibility, FinancialsPlans, IMS,
// ProgramTypes, ProjectTypes) are imported by `src/pages/admin/adminSections.tsx`
// and rendered inside the accordion tree — they no longer need their own routes.
//
// Legacy admin paths from D.2b / earlier (/admin/userSettings, /admin/clin, etc.)
// resolve via <Navigate> redirects to the appropriate new scope tab so existing
// bookmarks keep working.

// Define routes in an array and sort by path
const routes = [
  { path: '/', element: <Home /> },
  { path: '/about', element: <About /> },

  // D.4 Admin landing — the three scope tabs live under this single component.
  { path: '/admin', element: <AdminLanding /> },
  { path: '/admin/user-access', element: <AdminLanding /> },
  { path: '/admin/platform', element: <AdminLanding /> },
  { path: '/admin/program', element: <AdminLanding /> },
  { path: '/admin/project', element: <AdminLanding /> },
  { path: '/admin/advanced', element: <AdminLanding /> },

  // Legacy admin path redirects (bookmarks from earlier menu structure).
  { path: '/admin/userSettings', element: <Navigate to="/admin/user-access" replace /> },
  { path: '/admin/settings', element: <Navigate to="/admin/platform" replace /> },
  { path: '/admin/formVisibility', element: <Navigate to="/admin/platform" replace /> },
  { path: '/admin/access', element: <Navigate to="/admin/platform" replace /> },
  { path: '/admin/configuration', element: <Navigate to="/admin/platform" replace /> },
  { path: '/admin/clin', element: <Navigate to="/admin/platform" replace /> },
  { path: '/admin/contacts', element: <Navigate to="/admin/platform" replace /> },
  { path: '/admin/organizations', element: <Navigate to="/admin/platform" replace /> },
  { path: '/admin/locations', element: <Navigate to="/admin/platform" replace /> },
  { path: '/admin/objectTypes', element: <Navigate to="/admin/platform" replace /> },
  { path: '/admin/workflow', element: <Navigate to="/admin/platform" replace /> },
  { path: '/admin/etl/invoiceUpload', element: <Navigate to="/admin/platform" replace /> },
  { path: '/admin/financialPlans', element: <Navigate to="/admin/platform" replace /> },
  { path: '/admin/ims', element: <Navigate to="/admin/platform" replace /> },
  { path: '/admin/programDeliverableTypes', element: <Navigate to="/admin/program" replace /> },
  { path: '/admin/projectDeliverableTypes', element: <Navigate to="/admin/project" replace /> },

  { path: '/clins', element: <Clins /> },
  { path: '/ctp', element: <CTPForm /> },
  { path: '/ctp/:id', element: <CTPForm /> },
  { path: '/ctp-list', element: <CTPList /> },
  { path: '/approvalQueue', element: <ApprovalQueue /> },
  { path: '/deliverables', element: <Deliverables /> },
  { path: '/dodlinks', element: <Dodlinks /> },
  { path: '/feedback', element: <Feedback /> },
  { path: '/financials', element: <Financials /> },
  // { path: '/forms/:kapp/:form', element: <KineticFormPage /> },
  { path: '/help', element: <Help /> },
  { path: '/inventory', element: <Inventory /> },
  { path: '/iro', element: <IRO /> },
  { path: '/library', element: <Library /> },
  { path: '/logistics', element: <Logistics /> },
  { path: '/master-schedule', element: <MasterSchedule /> },
  { path: '/notifications', element: <Notifications /> },
  { path: '/org', element: <Org /> },
  { path: '/personnel', element: <Personnel /> },
  { path: '/pnr', element: <PNRForm /> },
  { path: '/pnr/:id', element: <PNRForm /> },
  { path: '/pnr-list', element: <PNRList /> },
  { path: '/preferences', element: <Preferences /> },
  { path: '/projects', element: <Projects /> },
  { path: '/quality-control', element: <QualityControl /> },
  { path: '/rip', element: <RIPForm /> },
  { path: '/rip/:id', element: <RIPForm /> },
  { path: '/rip-list', element: <RIPList /> },
  { path: '/risk', element: <Risk /> },
  { path: '/settings', element: <Settings /> },
  { path: '/signin', element: <SignIn /> },
  { path: '/tar', element: <TARForm /> },
  { path: '/tar/:id', element: <TARForm /> },
  { path: '/tar-imcs', element: <IMCSTARForm /> },
  { path: '/tar-imcs/:id', element: <IMCSTARForm /> },
  { path: '/tar-imcs-list', element: <IMCSTARList /> },
  { path: '/tr', element: <TRForm /> },
  { path: '/tr/:id', element: <TRForm /> },
  { path: '/tr-list', element: <TRList /> },
  { path: '/tar-list', element: <TARList /> },
  { path: '/workflow', element: <WorkFlow /> },
].sort((a, b) => a.path.localeCompare(b.path));

export { routes };
